module.exports = __webpack_public_path__ + "media/images/bilhete_cortado_top-ed90aaa24e8cbb8ff8928fb7dcde45f1.svg";